import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main joy-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_brief_loader = _resolveComponent("brief-loader")!
  const _component_brief_error = _resolveComponent("brief-error")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_brief_loader, { key: 0 }))
      : (_ctx.error)
        ? (_openBlock(), _createBlock(_component_brief_error, { key: 1 }))
        : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_router_view, null, null, 512), [
      [_vShow, !_ctx.loading && !_ctx.error]
    ])
  ]))
}